import { FormattedMessage } from 'react-intl';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

const InternalErrorState = () => (
    <ErrorState
        headline={<FormattedMessage id="intl-msg:common.error.emptyState.headline" />}
        message={<FormattedMessage id="intl-msg:common.error.emptyState.message" />}
        buttons={[
            {
                text: <FormattedMessage id="intl-msg:common.error.emptyState.button" />,
            },
        ]}
        outerClassName={`display-flex justify-content-center max-width-100pct`}
    />
);

export default InternalErrorState;
